var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"v-show":!_vm.loading,"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}},[_vm._v(" Na tvoju emailovú adresu bolo zaslané nové heslo. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }